/* Тема оформления — личная настройка пользователя, потребитель общего хранилища
   lib/userPrefs.ts (ключ "theme", тот же, что пишет продукт «Настройки» напрямую в
   PUT /api/prefs). Кит поддерживает 4 темы (kit/v5/src/tokens.css: [data-theme="…"]),
   применяются через атрибут корневого элемента документа — сам кит темы не переключает.
   Локальный кеш ("osnova-theme" в localStorage) — только для мгновенного применения ДО
   первой отрисовки (см. public/index.html), не источник истины. */
import { loadAllPrefs, getPrefSync } from "./userPrefs";
export const THEMES = ["dark", "light", "sepia", "mono"];
const STORAGE_KEY = "osnova-theme";
const DEFAULT_THEME = "dark";
const PREFS_KEY = "theme";
export function isTheme(v) {
    return typeof v === "string" && THEMES.includes(v);
}
// applyTheme — единственное место, где ядро пишет признак темы на корневой элемент
// документа; кеширует значение для мгновенного применения при следующей загрузке.
export function applyTheme(theme) {
    document.documentElement.dataset.theme = theme;
    try {
        localStorage.setItem(STORAGE_KEY, theme);
    }
    catch {
        /* хранилище недоступно (приватный режим, квота) — тема просто не переживёт перезагрузку */
    }
}
// resolveTheme — источник истины: общее хранилище личных настроек (сеть — максимум раз
// за сессию, см. loadAllPrefs); отсутствие/сбой/незнакомое значение → тема по умолчанию.
export async function resolveTheme() {
    const all = await loadAllPrefs();
    const raw = all[PREFS_KEY];
    return isTheme(raw) ? raw : DEFAULT_THEME;
}
// currentThemeSync — чтение уже загруженного кеша префов (для повторных обращений после
// resolveTheme/loadAllPrefs), без похода в сеть.
export function currentThemeSync() {
    const raw = getPrefSync(PREFS_KEY);
    return isTheme(raw) ? raw : DEFAULT_THEME;
}
